// API相关常量
export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: '/auth/login',
    REGISTER: '/auth/register',
    VALIDATE: '/auth/validate',
  },
  PROMPTS: {
    BASE: '/prompts',
    SEARCH: '/prompts/search',
    CATEGORY: '/prompts/category',
  },
} as const;

// 本地存储键名
export const STORAGE_KEYS = {
  TOKEN: 'token',
  USER: 'user',
  THEME: 'theme',
  LANGUAGE: 'language',
} as const;

// 默认配置
export const DEFAULT_CONFIG = {
  API_TIMEOUT: 10000,
  TOAST_DURATION: 3000,
  DEBOUNCE_DELAY: 300,
  PAGE_SIZE: 20,
} as const;

// 提示词分类
export const PROMPT_CATEGORIES = [
  '写作',
  '编程',
  '翻译',
  '分析',
  '创意',
  '教育',
  '商务',
  '大神模版',
  '其他',
] as const;

// 主题选项
export const THEMES = {
  LIGHT: 'light',
  DARK: 'dark',
  SYSTEM: 'system',
} as const;

// 错误消息
export const ERROR_MESSAGES = {
  NETWORK: '网络连接失败，请检查网络状态',
  TIMEOUT: '请求超时，请稍后重试',
  UNAUTHORIZED: '身份验证失败，请重新登录',
  FORBIDDEN: '没有权限访问此资源',
  NOT_FOUND: '请求的资源不存在',
  SERVER_ERROR: '服务器错误，请稍后重试',
  UNKNOWN: '发生未知错误',
} as const;

// 成功消息
export const SUCCESS_MESSAGES = {
  LOGIN: '登录成功！欢迎回来',
  REGISTER: '注册成功！请登录',
  LOGOUT: '已退出登录',
  PROMPT_CREATED: '提示词创建成功！',
  PROMPT_UPDATED: '提示词更新成功！',
  PROMPT_DELETED: '提示词删除成功！',
} as const; 